/**
 * COURE.QUIZ.SERVICE.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CampaignDto { 
    shortcode?: string;
    serviceId?: string;
    campaignDescription?: string;
    ownerId?: string;
    keyword?: string;
    campaignName?: string;
    startDate?: Date;
    endDate?: Date;
}